import { createInstance } from 'i18next';

const i18n = createInstance({
  load: 'languageOnly',
  saveMissingPlurals: false,
  fallbackLng: 'en',
  ns: ['translation'],
  defaultNS: 'translation',
  debug: false,
  react: { useSuspense: false },
  resources: {
    en: {
      translation: {
        "ERROR_TEXT": "Invalid input parameter(s) for the component. Please check for the input",
        "ERROR_NO_STORE_ID": "Could not find store Id from API response",
        "ERROR_NO_COUNTRY_DATA": "Could not find country details from API response",
        "ERROR_NO_ATTRIBUTES": "No Attributes found",
        "ERROR_NO_USER_DATA": "No User data found",
        "ERROR_NO_COMPANY_DATA": "No Company data found",
        "ERROR_NO_BUSINESSTYPE_DATA": "No Business Types found",
        "ERROR": "Error: An error has been occurred. Please try again later",
        "TOOLTIP_VIEW": "View",
        "TOOLTIP_DELETE": "Delete",
        "BROWSE_ICON_ALT": "Browse Icon",
        "REGISTRATION": {
          "REGISTER_COMPANY": "Register your company as a {{- role}}",
          "USER_SECTION_NAME": "Please fill in the following user details.",
          "USER_SECTION_DESC": "By completing the company registration, you will automatically become the first admin user of your company account.",
          "FIRST_NAME": "First name",
          "LAST_NAME": "Last name",
          "EMAIL_ID": "E-mail",
          "SELECT": "Select",
          "TELEPHONE_NO": "Phone number",
          "COUNTRY_CODE": "Country code",
          "USER_DETAILS_TITLE": "User details",
          "COMPANY_DETAILS_TAB": "Company details",
          "TERMS_CONDITIONS_TEXT": "Terms & Conditions",
          "IS_REQUIRED": "{{- displayName}} is mandatory",
          "IS_INVALID": "{{- displayName}} is invalid",
          "DETAILS_SAVED": "Details saved successfully!",
          "SAVE": "Save & Exit",
          "NEXT": "Continue",
          "PROCEED": "Proceed",
          "SUBMIT": "Submit",
          "DIALOG_HEADING": "Are you sure you want to Submit?",
          "ORGANIZATION_NAME": "Company name",
          "BUSINESS_TYPE": "Business type",
          "GST": "GSTIN",
          "COUNTRY": "Country",
          "COVERED_UNDER_MSME": "Covered Under MSMED Act",
          "IF_YES_PLEASE_ENTER_MSME_NO": "If Yes, please enter MSME no.",
          "IF_YES_PLEASE_ENTER_MSME_NO_VALIDATION": "MSME No",
          "PSU_SEZ_COMPOUNDING_SCHEME": "PSU /SEZ / Under compounding scheme",
          "TDS_EXEMPTED": "TDS exempted u/s 197",
          "CORPORATE_EMAIL": "Corporate email",
          "COMPANY_CONTACT_NO": "Company Contact No",
          "SALES/ACCT_DEPT_EMAIL": "Sales/Acct Dept Email",
          "SALES/ACCT_DEPT_CONTACT_NO": "Sales/Acct Dept Contact No",
          "TELL_ABOUT_BUSINESS": "Please fill in the following information about your company{{- message}}",
          "AS_PER_W9": " as per W9 Certificate.",
          "TELL_ABOUT_BUSINESS_DESC": "For validation purposes please make sure that the information entered is correct. The corporate email address will be used for invoicing purposes.",
          "PAN_DETAILS": "Please fill in the PAN details",
          "PAN_DETAILS_DESC": "These will be used to validate the company information provided.",
          "PAN": "PAN",
          "PAN_FULL_NAME": "Full name (as per PAN)",
          "PAN_FULL_NAME_VALIDATION": "Full name",
          "ADDRESS_LINE1": "Address line 1",
          "ADDRESS_LINE2": "Address line 2",
          "STREET_NAME": "Street name",
          "STREET_NUMBER": "Street number",
          "DISTRICT": "District",
          "STATE/UT": "State/UT",
          "STATE": "State",
          "CITY": "City",
          "POSTAL_CODE": "ZIP code",
          "POSTAL_CODE_US": "ZIP+4",
          "POSTAL_CODE_US_VALIDATION": "ZIP code",
          "ALTERNATE_NO": "Alternate No",
          "VAT": "VAT ID", 
          "TIN":"EIN",         
          "ADDRESS_INFO": "Please fill in the company address information",
          "ADDRESS_DESC": "These address will be used as Billing Address in the Invoice.",
          "SHIPPING_ADDRESS": "Shipping Address",
          "SHIPPING_ADDRESS_SAME_AS_BILLING": "Shipping address is same as the billing address",
          "AS_PER_GST": "As per the address in GST certificate",
          "YES": "yes",
          "NO": "no",
          "INVALID_POST_CODE": "Invalid Postal Code",
          "INVALID_GST": "Invalid GST Number",
          "INVALID_PAN": "Invalid PAN Details",
          "BACK": "Back",
          "TAX_DETAILS": "Please fill in the tax details",
          "TAX_DETAILS_DESC": "These will be used to validate the company information provided.",
          "MAX_CHARACTER_LIMIT": "Maximum character limit is {{charLimit}}",
          "MSME_HELPER_TEXT": "E.g. UDYAM-XX-123456789",
          "POSTAL_CODE_US_HELPER_TEXT": "E.g. 12345-0000",
          "COUNT_VALIDATION": "Character count should be less than or equal to {{- countValue}}",
          "DATA_POLICY": "Data protection notice",          
          "MARKETPLACE": "Marketplace",
          "TERMS_SECTION_HEADING": "Marketplace Terms and Conditions",
          "READ_AGREE_TEXT": "I have read and agree to the",
          "PRODUCT_PERMISSION_HEADING": "Product Management Permissions",
          "PRODUCT_PERMISSION_DESCRIPTION": "I hereby authorize the platform operator to perform solution onboarding and listing activities on behalf of my company",
          "BROWSE": "Browse",
          "DRAG_HERE": "or Drag it here",
          "DOCUMENT_NOT_SUPPORTED": "Document type not supported! Please attach valid document of type",
          "DOCUMENT_SIZE_NOT_SUPPORTED": "Document size not supported! Please attach document of size less than",
          "DOCUMENT_LENGTH_EXCEEDED": "Exceeding max upload file count. Please remove to add new files",
          "DOCUMENT_DELETE_SUCCESSFUL": "Document deleted successfully",
          "DOCUMENT_UPLOAD_SUCCESSFUL": "Document uploaded successfully",
          "MAX_FILE_SIZE": "Maximum file size is",
          "DOCUMENTS_KYC_DESCRIPTION": "These documents will be used for KYC.",
          "DOCUMENTS_UPLOAD": "Documents Upload",
          "PAN_CARD": "PAN Card",
          "GSTIN_CERTIFICATE": "GSTIN Certificate",
          "ADDRESS_ANNEXURE": "With Address Annexure",
          "W9_CERTIFICATE": "W9 Certificate",
          "W9_CERTIFICATE_DESC": "Fill and Upload W9 certificate.",
          "VAT_ID_CERTIFICATE": "Copy of VAT ID Certificate",
          "CORPORATE_AGREEMENT": "Corporate Agreement",
          "LEGAL_AGREEMENT": "Legal Agreement",
          "COMPANY_ERROR": "Unable to save Company Details",
          "SUCCESS_MESSAGE_HEADING": "Request Submitted Successfully",
          "SUCCESS_MESSAGE_DESCRIPTION_1": "Your Company details will be validated and approved by the Admin.",
          "SUCCESS_MESSAGE_DESCRIPTION_2": "You will receive notification to your email shortly.",
          "OKAY":"Okay"
        }
      }
    },
    de: {
      translation: {
        "ERROR_TEXT": "Ungültige Eingabeparameter für die Komponente. Bitte überprüfen Sie die Eingabe",
        "ERROR_NO_STORE_ID": "Die Store-ID konnte in der API-Antwort nicht gefunden werden",
        "ERROR_NO_COUNTRY_DATA": "In der API-Antwort konnten keine Länderdetails gefunden werden",
        "ERROR_NO_ATTRIBUTES": "Keine Attribute gefunden",
        "ERROR_NO_USER_DATA": "Keine Benutzerdaten gefunden",
        "ERROR_NO_COMPANY_DATA": "Keine Unternehmensdaten gefunden",
        "ERROR_NO_BUSINESSTYPE_DATA": "Keine Unternehmenstypen gefunden",
        "ERROR": "Fehler: Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal",
        "TOOLTIP_VIEW": "Sicht",
        "TOOLTIP_DELETE": "Löschen",
        "BROWSE_ICON_ALT": "Durchsuchen-Symbol",
        "REGISTRATION": {
          "REGISTER_COMPANY": "Registrieren Sie Ihr Unternehmen als {{- role}}",
          "USER_SECTION_NAME": "Bitte geben Sie die folgenden Benutzerdaten ein.",
          "USER_SECTION_DESC": "Mit Abschluss der Firmenregistrierung werden Sie automatisch der erste Admin-Benutzer Ihres Firmenkontos.",
          "FIRST_NAME": "Vorname",
          "LAST_NAME": "Familienname, Nachname",
          "EMAIL_ID": "Email",
          "SELECT": "Wählen",
          "TELEPHONE_NO": "Telefonnummer",
          "COUNTRY_CODE": "Landesvorwahl",
          "USER_DETAILS_TITLE": "Nutzerdetails",
          "COMPANY_DETAILS_TAB": "Firmendetails",
          "TERMS_CONDITIONS_TEXT": "Allgemeine Geschäftsbedingungen",
          "IS_REQUIRED": "{{- displayName}} ist obligatorisch",
          "IS_INVALID": "{{- displayName}} ist ungültig",
          "DETAILS_SAVED": "Details erfolgreich gespeichert!",
          "SAVE": "Sicherer Ausgang",
          "NEXT": "Weitermachen",
          "PROCEED": "Fortfahren",
          "SUBMIT": "Senden",
          "DIALOG_HEADING": "Sind Sie sicher, dass Sie einreichen möchten?",          
          "ORGANIZATION_NAME": "Name der Firma",
          "BUSINESS_TYPE": "Unternehmensart",
          "GST": "GSTIN",
          "COUNTRY": "Land",
          "COVERED_UNDER_MSME": "Abgedeckt durch das MSMED-Gesetz",
          "IF_YES_PLEASE_ENTER_MSME_NO": "Wenn ja, geben Sie bitte die MSME-Nummer ein",
          "IF_YES_PLEASE_ENTER_MSME_NO_VALIDATION": "MSME-Nr",
          "PSU_SEZ_COMPOUNDING_SCHEME": "PSU/SEZ/Im Rahmen des Compounding Scheme",
          "TDS_EXEMPTED": "TDS-befreit, u/s 197",
          "CORPORATE_EMAIL": "Corporate E-Mail",
          "COMPANY_CONTACT_NO": "Firmenkontakt-Nr",
          "SALES/ACCT_DEPT_EMAIL": "E-Mail der Vertriebs-/Kontoabteilung",
          "SALES/ACCT_DEPT_CONTACT_NO": "Kontaktnummer der Vertriebs-/Abteilungsabteilung",
          "TELL_ABOUT_BUSINESS": "Bitte füllen Sie die folgenden Informationen zu Ihrem Unternehmen aus.",
          "AS_PER_W9": " nach W9-Zertifikat.",
          "TELL_ABOUT_BUSINESS_DESC": "Bitte stellen Sie zur Validierung sicher, dass die eingegebenen Informationen korrekt sind. Für die Rechnungsstellung wird die Firmen-E-Mail-Adresse verwendet.",
          "PAN_DETAILS": "Bitte füllen Sie die PAN-Details aus",
          "PAN_DETAILS_DESC": "Diese werden zur Validierung der bereitgestellten Unternehmensinformationen verwendet.",
          "PAN": "PAN",
          "PAN_FULL_NAME": "Vollständiger name (nach PAN)",
          "PAN_FULL_NAME_VALIDATION": "Vollständiger Name",
          "ADDRESS_LINE1": "Anschrift Zeile 1",
          "ADDRESS_LINE2": "Adresszeile 2",
          "STREET_NAME": "Straßenname",
          "STREET_NUMBER": "Hausnummer",
          "DISTRICT": "Bezirk",
          "STATE/UT": "Bundesstaat/UT",
          "STATE": "Zustand",
          "CITY": "Stadt",
          "POSTAL_CODE": "PLZ",
          "POSTAL_CODE_US": "ZIP+4",
          "POSTAL_CODE_US_VALIDATION": "PLZ",
          "ALTERNATE_NO": "Alternative Nr",
          "VAT": "Umsatzsteuer-ID",
          "TIN":"EIN", 
          "ADDRESS_INFO": "Bitte geben Sie die Firmenadresse ein",
          "ADDRESS_DESC": "Diese Adresse wird als Rechnungsadresse in der Rechnung verwendet.",          
          "SHIPPING_ADDRESS": "Lieferanschrift",
          "SHIPPING_ADDRESS_SAME_AS_BILLING": "Die Lieferadresse entspricht der Rechnungsadresse",
          "AS_PER_GST": "Gemäß der Adresse im GST-Zertifikat",
          "YES": "Ja",
          "NO": "NEIN",
          "INVALID_POST_CODE": "Ungültige Postleitzahl",
          "INVALID_GST": "Ungültige GST-Nummer",
          "INVALID_PAN": "Ungültige PAN-Details",
          "BACK": "Zurück",
          "TAX_DETAILS": "Bitte geben Sie die Steuerdetails ein",
          "TAX_DETAILS_DESC": "Diese werden zur Validierung der bereitgestellten Unternehmensinformationen verwendet.",
          "MAX_CHARACTER_LIMIT": "Die maximale Zeichenbeschränkung beträgt {{charLimit}}",
          "MSME_HELPER_TEXT": "Z.B. UDYAM-XX-123456789",
          "POSTAL_CODE_US_HELPER_TEXT": "Z.B. 12345-0000",
          "COUNT_VALIDATION": "Die Zeichenanzahl sollte kleiner oder gleich sein {{- countValue}}",
          "DATA_POLICY": "Datenschutzhinweise",          
          "MARKETPLACE": "Marktplatz",
          "TERMS_SECTION_HEADING": "Allgemeine Geschäftsbedingungen für den Marktplatz",
          "READ_AGREE_TEXT": "Ich habe die ... gelesen und stimme ihnen zu",
          "PRODUCT_PERMISSION_HEADING": "Produktverwaltungsberechtigungen",
          "PRODUCT_PERMISSION_DESCRIPTION": "Hiermit ermächtige ich den Plattformbetreiber, im Namen meines Unternehmens Lösungs-Onboarding- und Listingaktivitäten durchzuführen",
          "BROWSE": "Durchsuche",
          "DRAG_HERE": "oder Ziehen Sie es hierher",
          "DOCUMENT_NOT_SUPPORTED": "Dokumenttyp nicht unterstützt! Bitte fügen Sie ein gültiges Dokument dieser Art bei",
          "DOCUMENT_SIZE_NOT_SUPPORTED": "Dokumentgröße wird nicht unterstützt! Bitte fügen Sie ein Dokument mit einer Größe von weniger als bei",
          "DOCUMENT_LENGTH_EXCEEDED": "Die maximale Anzahl hochgeladener Dateien wurde überschritten. Bitte entfernen, um neue Dateien hinzuzufügen",
          "DOCUMENT_DELETE_SUCCESSFUL": "Dokument erfolgreich gelöscht",
          "DOCUMENT_UPLOAD_SUCCESSFUL": "Dokument erfolgreich hochgeladen",
          "MAX_FILE_SIZE": "Die maximale Dateigröße beträgt",
          "DOCUMENTS_UPLOAD": "Hochladen von Dokumenten",
          "PAN_CARD": "PAN-Karte",
          "GSTIN_CERTIFICATE": "GSTIN-Zertifikat",
          "ADDRESS_ANNEXURE": "Mit Adressanhang",
          "W9_CERTIFICATE": "W9-Zertifikat",
          "W9_CERTIFICATE_DESC": "W9-Zertifikat ausfüllen und hochladen.",
          "VAT_ID_CERTIFICATE": "Kopie der Umsatzsteuer-ID-Bescheinigung",
          "CORPORATE_AGREEMENT": "Unternehmensvereinbarung",
          "LEGAL_AGREEMENT": "Rechtliches Übereinkommen",
          "COMPANY_ERROR": "Firmendetails können nicht gespeichert werden",
          "SUCCESS_MESSAGE_HEADING": "Anfrage erfolgreich gesendet",
          "SUCCESS_MESSAGE_DESCRIPTION_1": "Ihre Firmendaten werden vom Administrator validiert und genehmigt.",
          "SUCCESS_MESSAGE_DESCRIPTION_2":"Sie erhalten in Kürze eine Benachrichtigung per E-Mail.",
          "OKAY":"Okay"      
        }
      }
    }
  }
});

export default i18n;
